import styled from 'styled-components';

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const ConfirmText = styled.div`
  font-size: 15px;
  line-height: 22px;
  color: #374151;
`;

export const LeadCountBadge = styled.span`
  font-weight: 700;
  color: #2d6cdf;
`;

export const ButtonRow = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 4px;
`;

export const CancelButton = styled.button`
  flex: 1;
  height: 44px;
  background: #ffffff;
  border: 1px solid #cad5e2;
  border-radius: 10px;
  font-weight: 500;
  font-size: 14px;
  color: #212529;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #f8fafc;
    border-color: #94a3b8;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ConfirmButton = styled.button`
  flex: 1;
  height: 44px;
  background: linear-gradient(90deg, #296bcd 0%, #173a70 100%);
  border: none;
  border-radius: 10px;
  font-weight: 500;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    background: linear-gradient(90deg, #1e5bb8 0%, #0f2a54 100%);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ErrorMessage = styled.div`
  padding: 12px;
  background: #fee2e2;
  border: 1px solid #fca5a5;
  border-radius: 8px;
  color: #dc2626;
  font-size: 14px;
  line-height: 20px;
`;
